import {
  FETCH_CMS_LANGUAGES_REQUEST,
  FETCH_CMS_LANGUAGES_SUCCESS,
  FETCH_CMS_LANGUAGES_FAILURE,
  SAVE_CMS_LANGUAGE_REQUEST,
  SAVE_CMS_LANGUAGE_SUCCESS,
  SAVE_CMS_LANGUAGE_FAILURE,
  DELETE_CMS_LANGUAGE_REQUEST,
  DELETE_CMS_LANGUAGE_SUCCESS,
  DELETE_CMS_LANGUAGE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  cmsLanguageList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CMS_LANGUAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CMS_LANGUAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        cmsLanguageList: action.payload,
      };

    case FETCH_CMS_LANGUAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        cmsLanguageList: [],
      };
    case SAVE_CMS_LANGUAGE_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_CMS_LANGUAGE_SUCCESS:
      return {
        ...state,
      };

    case SAVE_CMS_LANGUAGE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_CMS_LANGUAGE_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_CMS_LANGUAGE_SUCCESS:
      return {
        ...state,
      };

    case DELETE_CMS_LANGUAGE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
